module.exports = __webpack_public_path__ + "img/banner_per.1a765a28.svg";